import React from 'react'
import {stringToHML} from './generalfunctions.jsx'


const Produkt = (props)=>{

    const produkt = props.produkt

    const src=`/media/albumthumbs/${produkt.cover_image}`

    let covertextsmall = null
    if (produkt.stilrichtung !== ""){
        covertextsmall =(
            <div className="album-cover-text album-cover-text-small">{produkt.stilrichtung}</div>
        )
    }
    let covertextsmaller = null
    if (produkt.stilrichtung2 !== ""){
        covertextsmaller =(
            <div className="album-cover-text album-cover-text-smaller">{produkt.stilrichtung2}</div>
        )
    }

    let label=null
    if (produkt.cover_image === "albumthumbnail.png" || produkt.cover_image === "guitarexercise.png"){
        label= (
            <>
                <div className="album-cover-text album-cover-text-big">
                    {stringToHML(produkt.thema)}
                </div>
                {covertextsmall}
                {covertextsmaller}                  
            </>
        )            
    }

    let divShopping = null        
    if (props.gekauft(produkt)===false && produkt.preis > 0 ){
        divShopping=(
            <div className="btn btn-sm" onClick={()=>props.inDenEinkaufswagen(produkt)} style={{width:'140px',height:'35px', position:'absolute', bottom:'-20px', right:'20px', borderRadius:'7px',color:'#f8f098', backgroundColor:'#151c5d', cursor:'pointer'}}>
                <i className="material-icons"> add_shopping_cart</i> {produkt.preis.toFixed(2)} €
            </div>
        )
    }
    if (props.gekauft(produkt)){
        divShopping=(
            <div  style={{color:'black', width:'30px',height:'30px', position:'absolute', bottom:'-7px', right:'5px', borderRadius:'7px', backgroundColor:'green', color:'white'}}>
                <i className="material-icons">  check </i>
            </div>
        )
    }
    if (props.zeigePreis !== undefined && props.zeigePreis===false)divShopping=null

    return(
        <div className="col-sm-12 col-md-6 col-lg-4 col-xl-3 col-xxl-1"  style={{width:'200px',height:'275px',  padding:'2px',  margin:'10px',  position:'relative'}}>                
            <a href="#" onClick={()=>props.zeigeProdukt(produkt, props.root)}>                   
                <img src={src} className="img-fluid card" alt={produkt.thema} />   
                {label}
            </a>
            {divShopping}
        </div>
              
    )

}


export default Produkt